import React from 'react'
import Educator from '../components/details/educator'

function educator() {
  return (
    <Educator />
  )
}

export default educator;